import clsx from "clsx";
import { useEffect, useRef } from "react";
import { Trans } from "react-i18next";
import { useCalculator } from "../../hooks/useCalculator";
import { CalculatorBack } from "../calculator-back/CalculatorBack";
import { CalculatorModule } from "../calculator-module/CalculatorModule";
import styles from "./CalculatorCustom.module.css";

export const CalculatorCustom: React.FC<{
  className?: string;
}> = ({ className }) => {
  const config = useCalculator((state) => state.config);
  const getState = useCalculator((state) => state.getState);
  const setCustomActive = useCalculator((state) => state.setCustomActive);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (ref.current !== null) {
        const rect = ref.current.getBoundingClientRect();
        const state = getState();

        const isScrollIntoViewRequired =
          state.isCustomScrollIntoViewAvailable === true &&
          state.isCustomActive === true &&
          rect.top < 0;

        if (isScrollIntoViewRequired === true) {
          ref.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }
    }, 300);

    return () => {
      clearTimeout(timeout);
    };
  }, [getState]);

  return (
    <div ref={ref} className={clsx(styles.custom, className)}>
      <div className={styles.header}>
        <CalculatorBack onClick={() => setCustomActive(false)} />
        <div className={styles.heading}>
          <Trans>Accounts</Trans>
        </div>
        <div className={styles.heading}>
          <Trans>Per Month</Trans>
        </div>
      </div>

      {config.modules.map((module) => (
        <CalculatorModule key={module.id} module={module} />
      ))}
    </div>
  );
};
